import { API_URL, itemPerPage } from '../constants/index.js';
import {
    POST_VERSION,
    POST_VERSION_ERROR,
    POST_VERSION_SUCCESS,
    STAGINPATH,
    PRODUCTIONPATH,
    GET_ALL_VERSIONS,
    GET_ALL_VERSIONS_SUCCESS,
    GET_ALL_VERSIONS_ERROR,
    PUT_VERSION,
    PUT_VERSION_SUCCESS,
    PUT_VERSION_ERROR,
    PUT_COMMUNITY_VERSION,
    PUT_COMMUNITY_VERSION_SUCCESS,
    PUT_COMMUNITY_VERSION_ERROR,
    GET_ALL_VERSIONS_BY_COMMUNITY,
    GET_ALL_VERSIONS_BY_COMMUNITY_SUCCESS,
    GET_ALL_VERSIONS_BY_COMMUNITY_ERROR,
    CLEAR_VERSIONS
} from '../constants/versionConstants';


//Alert
import { sweetAlert } from '../components/Alert/sweetAlert'

//#region GET ALL VERSION
export function getAllVersions(data) {
    return {
        type: GET_ALL_VERSIONS,
        data
    }
};

export function getAllVersionsSuccess(data) {
    return {
        type: GET_ALL_VERSIONS_SUCCESS,
        data
    }
};

export function getAllVersionsError(data) {
    return {
        type: GET_ALL_VERSIONS_ERROR,
        data
    }
};

export function GetAllVersions(VersionsForEnviroment = undefined) {
    return async dispatch => {

        dispatch(getAllVersions());


        const url = `${API_URL}eHubVersion/getAllVersions`;
        
        const options =
            VersionsForEnviroment ?
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        'VersionsForEnviroment': VersionsForEnviroment
                    }
                } :
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }

        const res = await fetch(url, options);

        let resJSON = undefined;

        if (!res || !res.ok) {
            return dispatch(getAllVersionsError(`Error status: ${res.status}`));
        }

        if (res) {
            resJSON = await res.json();
        } else {
            return dispatch(getAllVersionsError('Error response'));
        }

        if (resJSON && resJSON.data) {

            return dispatch(getAllVersionsSuccess(resJSON.data));
        } else {
            return dispatch(getAllVersionsError('Error: no json data'));
        }

    }

}
//#endregion

//#region GET VERSIONS BY COMMUNITY
export function getVersionsByCommunity(data) {
    return {
        type: GET_ALL_VERSIONS_BY_COMMUNITY,
        data
    }
};

export function getVersionsByCommunitySuccess(data) {
    return {
        type: GET_ALL_VERSIONS_BY_COMMUNITY_SUCCESS,
        data
    }
};

export function getVersionsByCommunityError(data) {
    return {
        type: GET_ALL_VERSIONS_BY_COMMUNITY_ERROR,
        data
    }
};

export function GetVersionsByCommunity(idCommunity, currentPage) {
    return async dispatch => {
        dispatch(getVersionsByCommunity());

        const url = `${API_URL}cms/eHubVersion/eHubVersionByCommunity?limit=${itemPerPage}&page=${currentPage}`;
        const options =
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'communityId': idCommunity
            }
        }

        const res = await fetch(url, options);

        let resJSON = undefined;

        if (!res || !res.ok) {
            return dispatch(getVersionsByCommunityError(`Error status: ${res.status}`));
        }

        if (res) {
            resJSON = await res.json();
        } else {
            return dispatch(getVersionsByCommunityError('Error response'));
        }

        if (resJSON) {

            return dispatch(getVersionsByCommunitySuccess(resJSON));
        } else {
            return dispatch(getVersionsByCommunityError('Error: no json data'));
        }

    }

}
//#endregion


//#region POST VERSION
export function postVersion(data) {
    return {
        type: POST_VERSION,
        data
    }
};

export function postVersionSuccess(data) {
    return {
        type: POST_VERSION_SUCCESS,
        data
    }
};

export function postVersionError(data) {
    return {
        type: POST_VERSION_ERROR,
        data
    }
};

export function PostVersion(version) {
    return dispatch => {
        dispatch(postVersion());

        const env = process.env.REACT_APP_HOST_NODE_ENV || 'production';

        if (env === 'dev' || env === 'development' || env === 'staging' || env === undefined || env === 'production') {

            //Stagging
            fetch(STAGINPATH + 'eHubVersion/addVersion',
                {
                    method: 'POST',
                    body: JSON.stringify(version),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                })
                .then(res => {
                    return res.json()
                }
                )
                .then(res => {

                    const message = `The new version has been added successfully`

                    dispatch(postVersionSuccess(res));

                    sweetAlert('success', message, 'alert_PostVersionStaging_Success');
                    return res;
                })
                .catch(error => {
                    dispatch(postVersionError(error));
                });

            // //Production
            fetch(PRODUCTIONPATH + 'eHubVersion/addVersion',
                {
                    method: 'POST',
                    body: JSON.stringify(version),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                })
                .then(res => {
                    return res.json()
                }
                )
                .then(res => {

                    const message = `The new version has been added successfully`

                    dispatch(postVersionSuccess(res));

                    sweetAlert('success', message, 'alert_PostVersionProduction_Success');
                    return res;
                })
                .catch(error => {
                    const message = `An error has occurred while adding the new version`
                    dispatch(postVersionError(error));

                    sweetAlert('error', message, 'alert_PostVersionProduction_error');

                })

        }
        if (env === 'local' || env === 'localhost') {
            fetch(API_URL + 'eHubVersion/addVersion',
                {
                    method: 'POST',
                    body: JSON.stringify(version),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                })
                .then(res => {
                    return res.json()
                }
                )
                .then(res => {

                    const message = `The new version has been added successfully`

                    dispatch(postVersionSuccess(res));

                    sweetAlert('success', message, 'alert_PostVersionLocal_Success');
                    return res;
                })
                .catch(error => {
                    const message = `An error has occurred while adding the new version`
                    dispatch(postVersionError(error));

                    sweetAlert('error', message, 'alert_PostVersionLocal_Error');

                })


        }



    }
};


//#endregion

//#region  PUT Version
export function putVersion(data) {
    return {
        type: PUT_VERSION,
        data
    }
};

export function putVersionSuccess(data) {
    return {
        type: PUT_VERSION_SUCCESS,
        data
    }
};

export function putVersionError(data) {
    return {
        type: PUT_VERSION_ERROR,
        data
    }
};

export function PutVersion(versionId, updateVersion) {
    return async dispatch => {
        //dispatch(putVersion());

        const url = `${API_URL}eHubVersion/putVersion/${versionId}`;
        const options = {
            method: 'PUT',
            body: JSON.stringify(updateVersion),
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }
        }

        const res = await fetch(url, options);

        let resJSON = undefined;

        if (!res || !res.ok) {
            sweetAlert('error', 'Error updating the version');
            return { status: res.status, ok: res.ok, message: 'error in response' }
            //dispatch(putVersionError(`Error status: ${res.status}`));
        }

        if (res) {
            resJSON = await res.json();
        } else {
            return { status: res.status, ok: res.ok, message: 'no json in response' }
            //dispatch(putVersionError('Error response'));
        }

        if (resJSON && resJSON.data) {
            sweetAlert('success', 'Version updated successfully', 'alert_UpdateVersion_Success');
            return { status: res.status, ok: res.ok, message: resJSON }
            //dispatch(putVersionSuccess(resJSON.data));
        } else {
            sweetAlert('success', 'Version updated successfully', 'alert_UpdateVersion_Success');
            return { status: res.status, ok: res.ok, message: 'no json in response' }
            //dispatch(putVersionError(' no json data'));
        }
    }
}
//#endregion

//#region  PUT Community Version
export function putCommunityVersion(data) {
    return {
        type: PUT_COMMUNITY_VERSION,
        data
    }
};

export function putCommunityVersionSuccess(data) {
    return {
        type: PUT_COMMUNITY_VERSION_SUCCESS,
        data
    }
};

export function putCommunityVersionError(data) {
    return {
        type: PUT_COMMUNITY_VERSION_ERROR,
        data
    }
};

export function PutCommunityVersion(versionId, updateVersion) {
    return async dispatch => {

        const url = `${API_URL}eHubVersion/communityVersion/${versionId}`;
        const options = {
            method: 'PUT',
            body: JSON.stringify(updateVersion),
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }
        }

        const res = await fetch(url, options);

        let resJSON = undefined;

        if (!res || !res.ok) {
            sweetAlert('error', 'Error updating the version', 'alert_PutCommunityVersion_Success');
            return { status: res.status, ok: res.ok, message: 'error en respuesta' }
        }

        if (res) {
            resJSON = res.json();
        } else {
            return { status: res.status, ok: res.ok, message: 'no json in response' }
        }

        if (resJSON && resJSON.data) {
            sweetAlert('success', 'Version updated successfully', 'alert_PutCommunityVersion_Success');
            return { status: res.status, ok: res.ok, message: resJSON }
        } else {
            sweetAlert('success', 'Version updated successfully', 'alert_PutCommunityVersion_Success');
            return { status: res.status, ok: res.ok, message: 'no json in response' }
        }
    }
}
//#endregion

export const ClearVersions = () => ({ type: CLEAR_VERSIONS});
